import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-m-com',
  templateUrl: './m-com.component.html',
  styleUrls: ['./m-com.component.scss']
})
export class MComComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
